<script>
  import superfood from '../../icons/icon-superfood-s.svg';
  import nuesse from '../../icons/icon-nuesse-s.svg';
  import trockenfruechte from '../../icons/icon-trockenfruechte-s.svg';
  import snacks from '../../icons/icon-snacks-s.svg';
  import backen from '../../icons/icon-backen-s.svg';
  import fruehstueck from '../../icons/icon-fruehstueck-s.svg';
  import zubehoer from '../../icons/icon-zubehoer-s.svg';
  import info from '../../icons/icon-info.svg';
  import plane from '../../icons/icon-transport-plane.svg';
  import ship from '../../icons/icon-transport-ship.svg';
  import transporter from '../../icons/icon-transport-transporter.svg';

  const icons = {
    superfood,
    nuesse,
    trockenfruechte,
    snacks,
    backen,
    fruehstueck,
    zubehoer,
    info,
    Schiff: ship,
    LKW: transporter,
    Flugzeug: plane
  };

  export let name = 'superfood';
  let className = '';
  export { className as class };
</script>

<span class="km-icon {className}">
  {@html icons[name]}
</span>
